(function () {
  'use strict';

  var MAP_ID = 'store-locator-map';
  var DEFAULT_CENTER = [45.1, 15.2];
  var DEFAULT_ZOOM = 7;
  var TILE_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
  var TILE_ATTR = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';

  var map, clusterGroup, allMarkers = [], pharmacies = [];
  var activeHighlightTimer = null;
  var currentFilteredPharmacies = null;
  var viewportTimer = null;
  var dataLoaded = false;
  var isInitialLoad = true;

  var container = document.getElementById('store-locator');
  if (!container) return;

  var mapEl = document.getElementById(MAP_ID);
  var input = container.querySelector('[data-sl-input]');
  var btnSearch = container.querySelector('[data-sl-search]');
  var btnGeo = container.querySelector('[data-sl-geo]');
  var counter = container.querySelector('[data-sl-counter]');
  var resultsEl = container.querySelector('[data-sl-results]');
  var maxResults = parseInt(container.dataset.slMax || '50', 10);
  var defaultZoom = parseInt(container.dataset.slZoom || String(DEFAULT_ZOOM), 10);

  function haversine(lat1, lng1, lat2, lng2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLng = (lng2 - lng1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function createTextEl(tag, className, text) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    el.textContent = text;
    return el;
  }

  function createLinkEl(href, text, className) {
    var a = document.createElement('a');
    a.href = href;
    a.textContent = text;
    if (className) a.className = className;
    return a;
  }

  function buildPopupNode(p) {
    var frag = document.createDocumentFragment();
    frag.appendChild(createTextEl('div', 'sl-popup__name', p.n));
    if (p.a) frag.appendChild(createTextEl('div', 'sl-popup__line', p.a));
    if (p.cp || p.v) {
      frag.appendChild(createTextEl('div', 'sl-popup__line', [p.cp, p.v].filter(Boolean).join(' ')));
    }
    if (p.pr) frag.appendChild(createTextEl('div', 'sl-popup__line', p.pr));
    if (p.t) {
      var phoneLine = document.createElement('div');
      phoneLine.className = 'sl-popup__line';
      phoneLine.appendChild(createLinkEl('tel:' + p.t, p.t));
      frag.appendChild(phoneLine);
    }
    var wrapper = document.createElement('div');
    wrapper.appendChild(frag);
    return wrapper;
  }

  /* ── Highlight card (clic marqueur → highlight + scroll) ── */
  function highlightCard(pharmacy) {
    if (!resultsEl) return;
    if (activeHighlightTimer) clearTimeout(activeHighlightTimer);
    var prev = resultsEl.querySelector('.wt-store-locator__card--active');
    if (prev) prev.classList.remove('wt-store-locator__card--active');

    var cards = resultsEl.querySelectorAll('.wt-store-locator__card');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i]._slPharmacy === pharmacy) {
        cards[i].classList.add('wt-store-locator__card--active');
        cards[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
        activeHighlightTimer = setTimeout(function () {
          cards[i].classList.remove('wt-store-locator__card--active');
        }, 4000);
        break;
      }
    }
  }

  function buildCardNode(p, onClick) {
    var card = document.createElement('div');
    card.className = 'wt-store-locator__card';
    card._slPharmacy = p;
    card.appendChild(createTextEl('p', 'wt-store-locator__card-name', p.n));
    if (p.a) card.appendChild(createTextEl('p', 'wt-store-locator__card-detail', p.a));
    if (p.cp || p.v) {
      card.appendChild(createTextEl('p', 'wt-store-locator__card-detail', [p.cp, p.v].filter(Boolean).join(' ')));
    }
    if (p.pr) card.appendChild(createTextEl('p', 'wt-store-locator__card-detail', p.pr));
    if (p.t) {
      var detail = createTextEl('p', 'wt-store-locator__card-detail', '');
      detail.appendChild(createLinkEl('tel:' + p.t, p.t));
      card.appendChild(detail);
    }
    if (onClick) card.addEventListener('click', onClick);
    return card;
  }

  function setCounter(count, total, mode) {
    if (!counter) return;
    if (mode === 'search') {
      counter.textContent = count.toLocaleString('hr-HR') + ' pronađene ljekarne';
    } else if (mode === 'viewport') {
      counter.textContent = count.toLocaleString('hr-HR') + ' vidljive ljekarne';
    } else {
      counter.textContent = total.toLocaleString('hr-HR') + ' ljekarne';
    }
  }

  /* ── Créer un marqueur avec popup + événement clic → highlight card ── */
  function createMarker(p) {
    var m = L.marker([p.lt, p.lg]);
    m.bindPopup(buildPopupNode(p), { className: 'sl-popup', maxWidth: 260 });
    m._slPharmacy = p;
    m.on('click', function () {
      this.openPopup();
      highlightCard(p);
    });
    return m;
  }

  function renderCards(list) {
    if (!resultsEl) return;
    while (resultsEl.firstChild) resultsEl.removeChild(resultsEl.firstChild);

    var show = list.slice(0, maxResults);
    show.forEach(function (p) {
      var card = buildCardNode(p, function (e) {
        if (e.target.tagName === 'A') return;
        if (p.lt != null && p.lg != null) {
          map.setView([p.lt, p.lg], 15, { animate: true });
          clusterGroup.eachLayer(function (layer) {
            if (layer._slPharmacy === p) {
              layer.openPopup();
            }
          });
          allMarkers.forEach(function (m) {
            if (m._slPharmacy === p) m.openPopup();
          });
          mapEl.scrollIntoView({ behavior: 'smooth' });
        }
      });
      resultsEl.appendChild(card);
    });
  }

  /* ── Cards dynamiques basées sur le viewport ── */
  function updateCardsFromViewport() {
    if (!dataLoaded) return;

    var bounds = map.getBounds();
    var currentDataset = currentFilteredPharmacies || pharmacies;

    var visible = currentDataset.filter(function (p) {
      if (!p.lt || !p.lg) return false;
      return bounds.contains([p.lt, p.lg]);
    });

    var center = map.getCenter();
    visible.sort(function (a, b) {
      var distA = Math.pow(a.lt - center.lat, 2) + Math.pow(a.lg - center.lng, 2);
      var distB = Math.pow(b.lt - center.lat, 2) + Math.pow(b.lg - center.lng, 2);
      return distA - distB;
    });

    var toShow = visible.slice(0, maxResults);

    var mode = currentFilteredPharmacies ? 'search' : 'viewport';
    setCounter(visible.length, pharmacies.length, mode);

    renderCards(toShow);
  }

  function search(query) {
    query = query.trim();
    if (!query) {
      resetView();
      return;
    }

    var q = query.toLowerCase();
    var isNumeric = /^\d+$/.test(q);

    var matched = pharmacies.filter(function (p) {
      if (isNumeric) {
        return p.cp && p.cp.indexOf(q) === 0;
      }
      return (p.v && p.v.toLowerCase().indexOf(q) !== -1) ||
        (p.n && p.n.toLowerCase().indexOf(q) !== -1) ||
        (p.pr && p.pr.toLowerCase().indexOf(q) !== -1);
    });

    currentFilteredPharmacies = matched;

    clusterGroup.clearLayers();
    var bounds = [];
    matched.forEach(function (p) {
      if (p.lt != null && p.lg != null) {
        var m = createMarker(p);
        clusterGroup.addLayer(m);
        bounds.push([p.lt, p.lg]);
      }
    });

    if (bounds.length > 0) {
      map.fitBounds(bounds, { padding: [40, 40], maxZoom: 14 });
      // moveend se déclenchera après fitBounds → updateCardsFromViewport() mettra à jour les cards
    } else {
      // Aucun résultat avec coordonnées : afficher les cards directement
      setCounter(matched.length, pharmacies.length, 'search');
      renderCards(matched);
    }
  }

  function resetView() {
    currentFilteredPharmacies = null;
    clusterGroup.clearLayers();
    allMarkers.forEach(function (m) { clusterGroup.addLayer(m); });
    map.setView(DEFAULT_CENTER, defaultZoom);
    // moveend se déclenchera → updateCardsFromViewport() mettra à jour les cards
  }

  function geolocate() {
    if (!navigator.geolocation) {
      alert('Geolokacija nije dostupna u vašem pregledniku.');
      return;
    }

    btnGeo.disabled = true;
    btnGeo.textContent = 'Lociranje…';

    navigator.geolocation.getCurrentPosition(
      function (pos) {
        var lat = pos.coords.latitude;
        var lng = pos.coords.longitude;

        var withDist = pharmacies
          .filter(function (p) { return p.lt != null; })
          .map(function (p) {
            p._dist = haversine(lat, lng, p.lt, p.lg);
            return p;
          })
          .sort(function (a, b) { return a._dist - b._dist; });

        currentFilteredPharmacies = withDist;

        clusterGroup.clearLayers();
        var bounds = [];
        var nearest = withDist.slice(0, maxResults);
        nearest.forEach(function (p) {
          if (p.lt != null && p.lg != null) {
            var m = createMarker(p);
            clusterGroup.addLayer(m);
            bounds.push([p.lt, p.lg]);
          }
        });

        if (bounds.length > 0) {
          map.fitBounds(bounds, { padding: [40, 40], maxZoom: 14 });
          // moveend se déclenchera → updateCardsFromViewport()
        }

        L.marker([lat, lng], {
          icon: L.divIcon({
            className: 'sl-user-marker',
            html: '<div style="width:14px;height:14px;background:#007aff;border:3px solid #fff;border-radius:50%;box-shadow:0 0 6px rgba(0,122,255,.5)"></div>',
            iconSize: [14, 14],
            iconAnchor: [7, 7]
          })
        }).addTo(map).bindPopup('Vaša lokacija');

        btnGeo.disabled = false;
        btnGeo.textContent = btnGeo.dataset.slLabel || 'Blizu mene';
      },
      function () {
        alert('Nije moguće dobiti vašu lokaciju. Provjerite jeste li dozvolili pristup.');
        btnGeo.disabled = false;
        btnGeo.textContent = btnGeo.dataset.slLabel || 'Blizu mene';
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  }

  function initMap() {
    map = L.map(MAP_ID, {
      center: DEFAULT_CENTER,
      zoom: defaultZoom,
      scrollWheelZoom: false,
      zoomControl: true,
      attributionControl: true
    });

    L.tileLayer(TILE_URL, {
      attribution: TILE_ATTR,
      maxZoom: 18,
      subdomains: ['a', 'b', 'c']
    }).addTo(map);

    clusterGroup = L.markerClusterGroup({
      chunkedLoading: true,
      chunkInterval: 200,
      chunkDelay: 50,
      maxClusterRadius: 60,
      spiderfyOnMaxZoom: false,
      zoomToBoundsOnClick: true,
      showCoverageOnHover: false,
      disableClusteringAtZoom: 18
    });

    map.addLayer(clusterGroup);

    // Clic cluster au zoom max ou même point → filtrer les cards
    clusterGroup.on('clusterclick', function (e) {
      var cluster = e.layer;
      var childMarkers = cluster.getAllChildMarkers();
      var bounds = cluster.getBounds();
      var canZoomMore = (map.getZoom() < map.getMaxZoom()) &&
        (bounds.getNorth() !== bounds.getSouth() || bounds.getEast() !== bounds.getWest());

      if (canZoomMore) return; // Laisser le zoomToBoundsOnClick agir

      // Cluster au zoom max ou tous les marqueurs au même point → filtrer les cards
      e.originalEvent.stopPropagation();

      var clusterPharmacies = childMarkers.map(function (m) {
        return m._slPharmacy;
      }).filter(Boolean);

      renderCards(clusterPharmacies.slice(0, maxResults));

      if (counter) {
        counter.textContent = clusterPharmacies.length.toLocaleString('hr-HR') + ' ljekarne na ovom području';
      }

      if (resultsEl) {
        resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    // Activer scroll zoom seulement sur clic dans la carte
    map.on('click', function () { map.scrollWheelZoom.enable(); });
    mapEl.addEventListener('mouseleave', function () { map.scrollWheelZoom.disable(); });

    // Écouter moveend avec debounce pour mettre à jour les cards
    map.on('moveend', function () {
      if (isInitialLoad) return; // Ignorer pendant le chargement initial
      clearTimeout(viewportTimer);
      viewportTimer = setTimeout(updateCardsFromViewport, 150);
    });

    // invalidateSize après rendu DOM
    setTimeout(function () { map.invalidateSize(); }, 150);
  }

  function loadData() {
    var jsonUrl = container.dataset.slJson;
    if (!jsonUrl) {
      console.error('Store Locator: data-sl-json URL missing');
      return;
    }

    fetch(jsonUrl)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        pharmacies = Array.isArray(data) ? data : data.pharmacies || [];

        var markerArray = [];
        pharmacies.forEach(function (p) {
          if (p.lt != null && p.lg != null) {
            var m = createMarker(p);
            allMarkers.push(m);
            markerArray.push(m);
          }
        });
        clusterGroup.addLayers(markerArray);

        var loading = mapEl.querySelector('.wt-store-locator__loading');
        if (loading) loading.remove();

        // Vue initiale FIXE sur la Croatie
        map.invalidateSize();
        map.setView(DEFAULT_CENTER, defaultZoom);

        dataLoaded = true;

        // Activer le moveend après stabilisation et faire la première mise à jour des cards
        setTimeout(function () {
          isInitialLoad = false;
          updateCardsFromViewport();
        }, 600);
      })
      .catch(function (err) {
        console.error('Store Locator: failed to load data', err);
      });
  }

  function bindEvents() {
    btnSearch.addEventListener('click', function () { search(input.value); });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        search(input.value);
      }
    });

    input.addEventListener('input', function () {
      if (input.value.trim() === '') resetView();
    });

    if (btnGeo) {
      btnGeo.addEventListener('click', geolocate);
    }
  }

  initMap();
  bindEvents();
  loadData();
})();
